<template src="./ReclamoWizard.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Step, Steps} from 'element-ui'
import {mapState} from 'vuex'
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";
import ReclamoDetailForm from "@/components/Ciudadano/Reclamos/ReclamoDetailForm/ReclamoDetailForm";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import {RouterMixin} from "@/mixins/routerMixin";
import SolicitudReclamoForm from "@/components/Ciudadano/Reclamos/SolicitudReclamoForm/SolicitudReclamoForm";
import ReclamoInicio from "@/components/Ciudadano/Reclamos/ReclamoInicio/ReclamoInicio";
import ReclamoNoValido from "@/components/Ciudadano/Reclamos/ReclamoNoValido/ReclamoNoValido";
import ReclamoExitoso from "@/components/Ciudadano/Reclamos/ReclamoExitoso/ReclamoExitoso";

export default {
  name: "ReclamoWizard",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Steps.name]: Steps,
    [Step.name]: Step,
    SolicitudReclamoForm,
    ReclamoDetailForm,
    ReclamoInicio,
    ReclamoNoValido,
    ReclamoExitoso
  },
  mixins: [
    requestAfiliacionMixin,
    ScreenSizeMixin,
    NotifyMixin,
    RouterMixin
  ],
  data() {
    return {
      reclamoPendiente: false,
      partidoSelecionado: '',
      loading: false,
      active: 0,
      model: {
        ciudadano: {}
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
  },
  methods: {
    onValidation(data) {
      this.$log.debug(data)
      this.reclamoPendiente = data
      this.active++
    },
    onNextStep(data) {
      this.$log.debug(data)
      this.model.ciudadano = data
      this.active++
    },
    onStepEnd() {
      this.active++
    },
    onPantallaInicio() {
      this.active = 0
    },
    onSolicitudReclamo() {
      this.active = 1
    }
  }
}
</script>


